module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-2000.03ce3915.svg";